import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";

const nav = [
  { to: "/", label: "Home" },
  { to: "/our-work", label: "Our Work" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-use", label: "Terms of Use" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-800 bg-[#040B16]"
    >
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Practical technology built to solve real-world problems, from a
              founder-led Florida technology company.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300">
              Company
            </h4>
            <ul className="mt-4 space-y-2.5">
              {nav.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-slate-400 transition-colors hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300">
              HILDRETH TECHNOLOGIES LLC
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-2.5">
                <MapPin size={16} className="mt-0.5 shrink-0 text-sky-400" />
                <span>Okeechobee, Florida</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail size={16} className="mt-0.5 shrink-0 text-sky-400" />
                <a
                  href="mailto:support@hildrethtechnology.com"
                  data-testid="footer-email"
                  className="transition-colors hover:text-white"
                >
                  support@hildrethtechnology.com
                </a>
              </li>
              <li className="text-slate-500">Founded 2026</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-slate-800/80 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 HILDRETH TECHNOLOGIES LLC. All rights reserved.</p>
          <p>HILDRETH TECHNOLOGIES LLC is a Florida limited liability company.</p>
        </div>
      </div>
    </footer>
  );
};
